import { Output, EventEmitter, Directive } from "@angular/core";
import { Validateable } from "@models";
import { Tradable } from "@models/interfaces/tradable";
import { tradableToArray } from "@helpers/tradable-convert";

@Directive()
export abstract class SummaryComponent extends Validateable {
	@Output()
	public edit = new EventEmitter<number>();
	@Output()
	public onClose = new EventEmitter<boolean>();
	@Output()
	// TODO: eslint fix
	// eslint-disable-next-line @angular-eslint/no-output-native
	public finish = new EventEmitter<unknown>();
	private _accepted = false;

	public cryptoStringArray: string[] = [];

	public abstract save(): void;

	public get accepted(): boolean {
		return this._accepted;
	}

	public set accepted(accepted: boolean) {
		this._accepted = accepted;
	}

	public setEdit(e: number): void {
		this.edit.emit(e);
	}

	public close(): void {
		this.onClose.emit();
	}

	protected setAmountShort(s: string, tradable: Tradable, zeroPrecision: boolean = false): void {
		this.cryptoStringArray = tradableToArray(s, tradable, true, zeroPrecision);
	}
}
